import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer>
    <div className="footer-grid">
      <div className="footer-brand">
        <div className="footer-logo-box">
          <img src="/assets/images/WhatsApp_Image_2026-06-11_at_14.59.14-removebg-preview.png" alt="Profibercom Logo" style={{ height: '66px' }} />
        </div>
        <p>Advanced Control, Instrumentation & Communication Systems for heavy industries, mining, manufacturing, and materials handling across Africa.</p>
        <div className="footer-social">
          <div className="fsoc" title="LinkedIn">in</div>
          <div className="fsoc" title="Facebook">f</div>
          <div className="fsoc" title="Twitter">𝕏</div>
          <div className="fsoc" title="Email">@</div>
        </div>
      </div>
      <div className="footer-col">
        <h4>Services</h4>
        <ul>
          <li><a href="#services">Control & Instrumentation</a></li>
          <li><a href="#services">Communication Systems</a></li>
          <li><a href="#services">Fiber Optic Installation</a></li>
          <li><a href="#services">Safety Interlocking</a></li>
          <li><a href="#contact">Technical Support</a></li>
        </ul>
      </div>
      <div className="footer-col">
        <h4>Products</h4>
        <ul>
          <li><a href="#products">HECU Systems</a></li>
          <li><a href="#products">Pull-Switch Safety</a></li>
          <li><a href="#products">GPON Networking</a></li>
          <li><a href="#products">PLCs & Automation</a></li>
          <li><a href="#products">Surveillance Systems</a></li>
        </ul>
      </div>
      <div className="footer-col">
        <h4>Industries</h4>
        <ul>
          <li><a href="#industries">Mining Operations</a></li>
          <li><a href="#industries">Materials Handling</a></li>
          <li><a href="#industries">Manufacturing</a></li>
          <li><a href="#industries">Water Reticulation</a></li>
          <li><a href="#industries">Power Generation</a></li>
        </ul>
      </div>
    </div>
    <div className="footer-bottom">
      <div>All rights reserved by Profibercom @2026</div>
      <div>Crafted for zero-harm industrial excellence | <a href="mailto:admin@profibercom.co.za">admin@profibercom.co.za</a></div>
    </div>
  </footer>
);

export default Footer;